import React from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { BASE_PATH } from "../../constants/awsBaseUrl";

export default class Modal extends React.Component {
  static contextType = GlobalContext;
  render() {
    const {darkMode} = this.context
    return (
      <div className={this.props.visible ? "login-wrapper" : "d-none"}>
        <div className="login-body">
          <div
            className="login-x"
            onClick={() => {this.props.close()}}
            style={{color:darkMode?'black':''}}
          >
            <i className="fas fa-times"></i>
          </div>
          <div
            className="login-title"
            style={{
              backgroundImage: `url('${BASE_PATH}/logos/${
                this.props.user
              }/banner.jpg?refresh=${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}')`,
            }}
          ></div>
          <h1 className="display-4 sm border-bottom">{this.props.title}</h1>
          {this.props.children}
        </div>
      </div>
    );
  }
}
